import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField, Typography, Box, Button, Card, CardContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Container, Grid2 } from '@mui/material';
import Swal from 'sweetalert2';
import ExcelJS from 'exceljs';
import { Backdrop, CircularProgress } from '@mui/material';
import { BASE_URL } from '../../App';
import axios from 'axios';
import Grid from '@mui/material/Grid';

const DEALERSalesReport = () => {
  const [Branch, setBranch] = useState("");
  const [DateFrom, setDateFrom] = useState("");
  const [DateTo, setDateTo] = useState("");
  const [showTable, setShowTable] = useState(false);

  const [Data, setData] = useState([]);
  const [tabledata, settabledata] = useState([]);
  const [Error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const login_id = localStorage.getItem("LOGIN_ID");
  const BRANCH_CODE = localStorage.getItem("BRANCH_CODE"); 
  const GROUP_CODE = localStorage.getItem("usertype"); 


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB');
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.post(BASE_URL + '/getbranchforreport', {
          login_id: login_id,
          branch_code: BRANCH_CODE
        });

        console.log("API Response:", response.data);

        if (response.data && response.data.Branchlist) {
          setData(response.data.Branchlist);
        } else {
          console.log("No Branchlist in response");
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleReportBranchChange = (e) => setBranch(e.value);
  const handleDateFromChange = (e) => setDateFrom(e.target.value);
  const handleDateToChange = (e) => setDateTo(e.target.value);

  const handleDownloadExcel = () => {
    if (tabledata.length === 0) {
      Swal.fire({
        icon: "info",
        text: 'No Data Available For export!'
      });
      return;
    }
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to download the Excel file?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, download it!',
      cancelButtonText: 'No, cancel!',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sales Report');

        worksheet.columns = Object.keys(tabledata[0]).map(key => ({ header: key, key }));

        tabledata.forEach(data => worksheet.addRow(data));

        const headerRow = worksheet.getRow(1);
        headerRow.eachCell((cell) => {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'bf43bb' }
          };
        });

        worksheet.autoFilter = {
          from: 'A1',
          to: 'I1'
        };

        setTimeout(() => {
          workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'Sales_Report.xlsx';
            link.click();
            setLoading(false);
          });
        }, 1000);
      }
    });
  };

  // const handleViewTable = async () => {
  //   setLoading(true);
  //   setError(null);

  //   if (!Branch || !DateFrom || !DateTo) {
  //     Swal.fire({
  //       icon: 'warning',
  //       text: 'Please fill all the fields (Branch, DateFrom, DateTo)',
  //     });
  //     setLoading(false);
  //     return;
  //   }

  //   try {
  //     const response = await axios.post(BASE_URL + '/getsalesreport', {
  //       branch_code: Branch,
  //       start_date: DateFrom,
  //       end_date: DateTo,
  //       usergroup_code: '1',
  //       login_id: 'MKT00117',
  //       user_branch_code: '1702',
  //     });

  //     console.log('API Response:', response.data);

  //     if (response.data && response.data.SalesReport) {
  //       settabledata(response.data.SalesReport);
  //       setShowTable(true);
  //     } else {
  //       setError('Unexpected response.message');
  //       setShowTable(false);
  //     }
  //   } catch (err) {
  //     setError('Failed to fetch data');
  //     console.error('Error fetching data: ', err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const handleViewTable = () => {
  //   setLoading(true);
  //   const data = {
  //     branch_code: Branch,
  //     start_date: DateFrom,
  //     end_date: DateTo,
  //     usergroup_code: GROUP_CODE,
  //     login_id: login_id,
  //     user_branch_code: BRANCH_CODE,
  //   };
  //   axios.post(BASE_URL + '/getsalesreport', data)
  //     .then(response => {
  //       if (response.status === 200) {
  //         settabledata(response.data.SalesReport);
  //         setShowTable(true);

  //       } else {
  //         Swal.fire({
  //           icon: "warning",
  //           text: 'Unexpected response status. Please try again.'
  //         });
  //       }
  //     })
  //     .catch(error => {
  //       if (error.response) {
  //         Swal.fire({
  //           icon: "warning",
  //           title: `${error.response.data.message}`
  //         });
  //       } else if (error.request) {
  //         console.error('No response received');
  //       } else {
  //         console.error('Error setting up the request:', error.message);
  //       }
  //     })
  //     .finally(() => {
  //       setLoading(false); // Close loading indicator regardless of success or failure
  //     });
  // };

  // const handleViewTableGroupBase = () => {
  //        excel_type: 'GroupBase'
  // }

  // const handleViewTableSlabBased = () => {
  //    excel_type: 'SlabBased'
  // }

  // const handleViewTableSerialNumber = () => {

  //   excel_type: 'SerialNumber'
  // }


  // const handleViewTable = () => {
  const handleViewTable = (type = 'allItems') => {
  setLoading(true);
  const data = {
    branch_code: Branch,
    start_date: DateFrom,
    end_date: DateTo,
    usergroup_code: GROUP_CODE,
    login_id: login_id,
    user_branch_code: BRANCH_CODE,
    excel_type: type
  };

  axios({
    url: BASE_URL + '/getsalesreport',
    method: 'POST',
    data: data,
    responseType: 'blob' // important for binary response
  })
    .then((response) => {
      if (response.status === 200) {
        // Use CSV MIME type
        const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `Sales_Report_${type}.csv`;  
        link.click();
      } else {
        Swal.fire({
          icon: "info",
          text: 'No data available to export!'
        });
      }
    })
    .catch((error) => {
      Swal.fire({
        icon: "error",
        title: 'Error downloading file!',
        text: error?.response?.data?.message || "Something went wrong."
      });
    })
    .finally(() => {
      setLoading(false);
    });
};



  return (
    <div>
      <br />
      <center>
      <Card className="shadow bg-white rounded" sx={{ padding: 3,width:'90%' }} >
      
          <Grid container spacing={2} direction="row" alignItems="center">
            <Grid item xs={12} lg={4}>
              <Autocomplete
                disablePortal
                options={Data}
                getOptionLabel={(option) => `${option.branch} - ${option.branch_name}`}
                renderInput={(params) => <TextField {...params} label="Branch" />}
                onChange={(event, value) => setBranch(value ? value.branch : '')}
                sx={{ width: '300px' }}
              />
            </Grid>

            <Grid item xs={12} lg={4}>
              <TextField
                label="Date From"
                type="date"
                value={DateFrom}
                onChange={handleDateFromChange}
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} lg={4}>
              <TextField
                label="Date To"
                type="date"
                value={DateTo}
                onChange={handleDateToChange}
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            </Grid>
          </Grid>

          <Box sx={{ display: 'flex', gap: 4, marginTop: 2 }}>
            <Button
              variant="contained"
              color="primary"
              style={{ width: '250px' }}
              onClick={() => handleViewTable('allItems')}
            >
              DOWNLOAD EXCEL
            </Button>

            <Button
              variant="contained"
              color="primary"
              style={{ width: '250px' }}
              onClick={() => handleViewTable('GroupBase')}
            >
              Group Based Excel
            </Button>

            <Button
              variant="contained"
              color="primary"
              style={{ width: '250px' }}
              onClick={() => handleViewTable('SlabBased')}
            >
              Slab Based Excel
            </Button>

            <Button
              variant="contained"
              color="primary"
              style={{ width: '250px' }}
              onClick={() => handleViewTable('SerialNumber')}
            >
              Serial Number Based Excel
            </Button>

            <Button
              variant="contained"
              sx={{
                backgroundColor: 'green',
                '&:hover': { backgroundColor: 'darkgreen' },
              }}
              style={{ width: '250px',display:'none' }}
              //  style={{ width: '250px' }}
              onClick={handleDownloadExcel}
             
            >
              Download Excel
            </Button>
          </Box>
    
      </Card>
      </center>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>

      {showTable && tabledata.length > 0 && (
        <Box sx={{ width: '100%', padding: 2, overflowX: 'auto', margin: 0 }}>
          <TableContainer component={Paper} sx={{ maxHeight: 500, width: '100%' }}>
            <Table sx={{ minWidth: 800, width: '100%' }} aria-label="Sales Report Table">
              <TableHead>

                <TableRow>

                  <TableCell style={{ position: 'sticky', top: 0, fontWeight: 'bold', backgroundColor: '#1976d2', color: 'white' }}>SERIAL_NO</TableCell>
                  <TableCell style={{ position: 'sticky', top: 0, fontWeight: 'bold', backgroundColor: '#1976d2', color: 'white' }}>DLRTORTL_INV_NO</TableCell>
                  <TableCell style={{ position: 'sticky', top: 0, fontWeight: 'bold', backgroundColor: '#1976d2', color: 'white' }}>DLRTORTL_INV_DATE</TableCell>
                  <TableCell style={{ position: 'sticky', top: 0, fontWeight: 'bold', backgroundColor: '#1976d2', color: 'white' }}>DEALER_CODE</TableCell>
                  <TableCell style={{ position: 'sticky', top: 0, fontWeight: 'bold', backgroundColor: '#1976d2', color: 'white' }}>PSG</TableCell>
                  <TableCell style={{ position: 'sticky', top: 0, fontWeight: 'bold', backgroundColor: '#1976d2', color: 'white' }}>ITEMCODE</TableCell>
                  <TableCell style={{ position: 'sticky', top: 0, fontWeight: 'bold', backgroundColor: '#1976d2', color: 'white' }}>ITEMDESCRIPTION</TableCell>
                  <TableCell style={{ position: 'sticky', top: 0, fontWeight: 'bold', backgroundColor: '#1976d2', color: 'white' }}>SUBDEALERCODE</TableCell>
                  <TableCell style={{ position: 'sticky', top: 0, fontWeight: 'bold', backgroundColor: '#1976d2', color: 'white' }}>SUBDEALERNAME</TableCell>
                  <TableCell style={{ position: 'sticky', top: 0, fontWeight: 'bold', backgroundColor: '#1976d2', color: 'white' }}>CREATEDBY</TableCell>
                  <TableCell style={{ position: 'sticky', top: 0, fontWeight: 'bold', backgroundColor: '#1976d2', color: 'white' }}>CREATEDON</TableCell>
                  <TableCell style={{ position: 'sticky', top: 0, fontWeight: 'bold', backgroundColor: '#1976d2', color: 'white' }}>MODIFIEDBY</TableCell>
                  <TableCell style={{ position: 'sticky', top: 0, fontWeight: 'bold', backgroundColor: '#1976d2', color: 'white' }}>MODIFIEDON</TableCell>
                  <TableCell style={{ position: 'sticky', top: 0, fontWeight: 'bold', backgroundColor: '#1976d2', color: 'white' }}>NAMEOFINCHARGE</TableCell>
                  <TableCell style={{ position: 'sticky', top: 0, fontWeight: 'bold', backgroundColor: '#1976d2', color: 'white' }}>LISTRATE</TableCell>
                  <TableCell style={{ position: 'sticky', top: 0, fontWeight: 'bold', backgroundColor: '#1976d2', color: 'white' }}>STATE_NAME</TableCell>
                  <TableCell style={{ position: 'sticky', top: 0, fontWeight: 'bold', backgroundColor: '#1976d2', color: 'white' }}>DISTRICT_NAME</TableCell>
                  <TableCell style={{ position: 'sticky', top: 0, fontWeight: 'bold', backgroundColor: '#1976d2', color: 'white' }}>CITY_NAME</TableCell>
                  <TableCell style={{ position: 'sticky', top: 0, fontWeight: 'bold', backgroundColor: '#1976d2', color: 'white' }}>AREA_NAME</TableCell>
                  <TableCell style={{ position: 'sticky', top: 0, fontWeight: 'bold', backgroundColor: '#1976d2', color: 'white' }}>PHONENO</TableCell>
                  <TableCell style={{ position: 'sticky', top: 0, fontWeight: 'bold', backgroundColor: '#1976d2', color: 'white' }}>MOBILENO</TableCell>
                  <TableCell style={{ position: 'sticky', top: 0, fontWeight: 'bold', backgroundColor: '#1976d2', color: 'white' }}>EMAILID</TableCell>
                  <TableCell style={{ position: 'sticky', top: 0, fontWeight: 'bold', backgroundColor: '#1976d2', color: 'white' }}>ACTIVE</TableCell>
                  <TableCell style={{ position: 'sticky', top: 0, fontWeight: 'bold', backgroundColor: '#1976d2', color: 'white' }}>STATUS</TableCell>
                  <TableCell style={{ position: 'sticky', top: 0, fontWeight: 'bold', backgroundColor: '#1976d2', color: 'white' }}>REGION_NAME</TableCell>
                                    <TableCell style={{ position: 'sticky', top: 0, fontWeight: 'bold', backgroundColor: '#1976d2', color: 'white' }}>RETAILER_POINTS</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tabledata.map((row, index) => (
                  <TableRow key={index}>
                    {Object.keys(row).map((key) => (
                      <TableCell key={key}>
                        {key === 'DLRTORTL_INV_DATE' || key === 'CREATEDON' || key === 'MODIFIEDON' ? formatDate(row[key]) : row[key]}
                      </TableCell>

                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}
    </div>
  );
};

export default DEALERSalesReport;





